/**
 * This is wrapper adds animation to any component you wrap it with. This file using the animations.css
 * Feel free to add animations to animations.css as you need them
 * You can preview animations here: https://covalent.netlify.app/
 *
 * <hh-animate-on-scroll
      data-target=<target>
      data-animation-class=<animation class>
      data-stagger-delay=<delay in ms between each child>
    >
    </hh-animate-on-scroll>
 *
 * @param {string} target The target element you want to animate
 * @param {string} animationClass The animation you want to apply to the target (See options in animations.css)
 * @param {number} [animationThreshold=0.25] The amount of the target element that will be visible when the animation is triggered
 * @param {number} [staggerDelay=100] The delay in milliseconds between each child element's animation
 */
class HHAnimateOnScroll extends HTMLElement {
  constructor() {
    super()
    this.observer = null;
    this.target = this.dataset.target || 'adaptive-image'
    this.animationClass = this.dataset.animationClass || 'zoomin'
    this.animationThreshold = this.dataset.animationThreshold || 0.25
    this.delay = parseInt(this.dataset.delay) || 0
    this.staggerDelay = parseInt(this.dataset.staggerDelay) || 100
    // This sets the inital state before the animation occurs
    this.classList.add(this.animationClass)
  }

  connectedCallback() {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mediaQuery.matches) return;

    // Set initial state
    this.style.opacity = '0';
    if (this.target.startsWith('.')) {
      // If target is a class selector
      const targetElements = this.querySelectorAll(this.target);
      targetElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = `opacity var(--animation-duration) var(--animation-easing), transform var(--animation-duration) var(--animation-easing)`;
      });
    } else {
      // If target is a tag selector
      const targetElements = this.getElementsByTagName(this.target);
      Array.from(targetElements).forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        el.style.transition = `opacity var(--animation-duration) var(--animation-easing), transform var(--animation-duration) var(--animation-easing)`;
      });
    }

    const intersectionOptions = {
      rootMargin: "0px 0px -150px 0px",
      threshold: this.animationThreshold,
    }

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Handle animation for the wrapper
          
          
          // Handle animation for target elements with stagger
          const animateElement = (el, index) => {
            setTimeout(() => {
              this.style.opacity = '1';
              el.style.opacity = '1';
              el.style.transform = 'none';
              el.classList.add(this.animationClass);
            }, (index * this.staggerDelay) + this.delay);
          };

          if (this.target.startsWith('.')) {
            const targetElements = this.querySelectorAll(this.target);
            targetElements.forEach((el, index) => animateElement(el, index));
          } else {
            const targetElements = this.getElementsByTagName(this.target);
            Array.from(targetElements).forEach((el, index) => animateElement(el, index));
          }
          
          // Disconnect observer after animation is triggered
          this.observer.disconnect();
        }
      });
    }, intersectionOptions);
    
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('hh-animate-on-scroll', HHAnimateOnScroll);
